<div class="h-full w-full grid grid-nogutter">
    <div class="col-3 flex flex-column pr-3 border-right-1 border-200">
        <div class="p-1 mb-2 flex align-items-center justify-content-between">
            <span class="font-bold text-2xl">Discussions</span>

            <p-button icon="fa-solid fa-pen-to-square" [rounded]="true" [text]="true"
                pTooltip="Démarrer une nouvelle discussion" tooltipPosition="bottom" showDelay="1000" hideDelay="300"
                (click)="onClickNewConversation()"></p-button>
        </div>
        <div class="flex-grow-1">
            <app-conversations-list [conversations]="conversations" [selectedConversation]="selectedConversation"
                (conversationSelected)="onConversationSelected($event)"></app-conversations-list>
        </div>
    </div>
    <div class="col-9 h-full flex flex-column">
        @if (!showConversationForm) {
        <app-conversation-details [conversation]="selectedConversation" [loading]="loading"
            (conversationChanged)="onConversationChanged($event)"
            (conversationCreated)="onConversationCreated($event)"></app-conversation-details>
        } @else {
        <app-conversation-form [conversation]="selectedConversation!" (cancel)="onCreationCancelled()" (saved)="onConversationSaved($event)"></app-conversation-form>
        }
    </div>
</div>